import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  PageListBean,
  RestReadRequest,
  RestVendorInvoiceListRequest,
  RestVendorListRequest,
  VendorInvoiceSearchCriteria,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { VendorService } from "../services/VendorService.js";
export class VendorInvoiceLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, searchCode, status) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.searchCode = searchCode;
    this.status = status;
    let resetCriteria = new VendorInvoiceSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let vendorInvoiceLookupCriteria = new VendorInvoiceSearchCriteria();
    vendorInvoiceLookupCriteria.companyCode = this.companyCode;
    vendorInvoiceLookupCriteria.vendorCode = this.searchCode;
    let newCriteria = new VendorInvoiceSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = VendorInvoiceLookupCriteraHandler(
      companyCode,
      vendorInvoiceLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      vendorInvoiceLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getVendorInvoiceStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Status", "status", 0, false); //1
    this.addColumnDefinition("VendorCode", "vendorCode", 0, false); //3
    this.addColumnDefinition("VendorName", "vendorName", 0, false); //3
    this.addColumnDefinition("InvoiceDate", "invoiceDate", 0, false); //3
    this.addColumnDefinition("InvoiceDueDate", "invoiceDueDate", 0, false); //3
    this.addColumnDefinition("CreatedDate", "createdDate", 0, false); //3
    this.addColumnDefinition("GrandTotalAmount", "grandTotalAmount", 1, false);
  }
  loadVendorInvoiceList = (lookup_dialog, pageNumber, searchCriteria) => {
    let inv_criteria = new VendorInvoiceSearchCriteria(); //To be fetched from CriteriaHandler
    inv_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      inv_criteria.vendorInvoiceCode = searchCriteria.vendorInvoiceCode;
      inv_criteria.vendorInvoiceReferenceNumber =
        searchCriteria.vendorInvoiceReferenceNumber;
      // inv_criteria.vendorCode = searchCriteria.vendorCode;
      inv_criteria.invoiceDate = searchCriteria.invoiceDate;
      inv_criteria.invoiceDueDate = searchCriteria.invoiceDueDate;
      inv_criteria.invoiceFromDate = searchCriteria.invoiceFromDate;
      inv_criteria.invoiceToDate = searchCriteria.invoiceToDate;
      inv_criteria.vendorType = searchCriteria.vendorType;
      if (!isEmptyString(this.searchCode)) {
        inv_criteria.vendorCode = this.searchCode;
      } else {
        inv_criteria.vendorCode = searchCriteria.vendorCode;
      }
      if (!isEmptyString(this.status)) {
        inv_criteria.status = this.status;
      } else {
        inv_criteria.status = searchCriteria.status;
      }
    }
    let invoice_pageList = new PageListBean();
    invoice_pageList.pageSize = 50; //TODO --> Fetch from Config
    invoice_pageList.pageNumber = pageNumber;
    invoice_pageList.currentPage = pageNumber;
    let po_requestInput = new RestVendorInvoiceListRequest();
    po_requestInput.pageInput = invoice_pageList;
    po_requestInput.searchCriteria = inv_criteria;
    AccountPayableService.getVendorInvoices(
      po_requestInput,
      (response) =>
        this.loadVendorInvoicesListResponse(response, lookup_dialog),
      this.loadVendorInvoiceListError
    );
  };
  loadVendorInvoicesListResponse = (response, lookup_dialog) => {
    let vendorList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.vendorInvoicePageList != null &&
      response.data.vendorInvoicePageList.vendorInvoices !== null
    ) {
      vendorList = response.data.vendorInvoicePageList.vendorInvoices;
      totalCount = response.data.vendorInvoicePageList.totalCount;
      currentPageNumber = response.data.vendorInvoicePageList.currentPage;
      pageSize = response.data.vendorInvoicePageList.pageSize;
      vendorList.map((vl) => {
        vl.status = ModuleUtils.getVendorInvoiceStatusCaption(vl.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = vendorList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadVendorInvoiceListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.vendorInvoiceCode)) {
      if (!isEmptyString(filterText)) {
        search.vendorInvoiceCode = filterText;
        this.searchCriteria = new VendorInvoiceSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadVendorInvoiceList(lookup_dialog, pageNumber, search);
    }
  }
}
const VendorInvoiceLookupCriteraHandler = (
  companyCode,
  vendorInvoiceLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new VendorInvoiceSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let vendorLookupHandler = new VendorLookupHandler(companyCode, "Vendor");
      this.setState({ vendorLookupHandler: vendorLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new VendorInvoiceSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };

    vendorCodeOnChange = (e) => {
      let vendorCode = e.target.value;
      this.state.showAutoCompleteVendorList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      if (isEmpty(vendorCode)) {
        this.state.showAutoCompleteVendorList = false;
        let showAutoCompleteList = this.state.showAutoCompleteVendorList;
        let criteria = this.state.searchCriteria;
        criteria.vendorCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: criteria,
          vendorPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "vendorCode" &&
        showAutoCompleteList === true &&
        vendorCode !== ""
      ) {
        this.readVendorBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetVendorDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      if (response.data != null && response.data.vendor != null) {
        let vendorData = response.data.vendor;
        if (!isEmpty(vendorData)) {
          criteria.vendorCode = vendorData.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetVendorDetail = (vendorCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = vendorCode;
      input.isLoadChildren = true;
      VendorService.readVendor(
        input,
        this.readandsetVendorDetailResponse,
        this.errorCallBack
      );
    };
    readVendorBySearchString(searchString) {
      let searchCriteria = new VendorSearchCriteria();
      searchCriteria.companyCode = companyCode;

      searchCriteria.vendorCodeStartsWith = searchString;
      searchCriteria.vendorNameContains = searchString;
      let pageList = new PageListBean();
      pageList.pageSize = 100;
      let input = new RestVendorListRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      VendorService.getVendorPageList(
        input,
        this.readByVendorCodeResponse,
        this.errorCallBack
      );
    }
    readByVendorCodeResponse = (response) => {
      if (
        response.data != null &&
        response.data.vendorPageList != null &&
        response.data.vendorPageList.vendors != null
      ) {
        let vendorCodeData = response.data.vendorPageList.vendors;
        let simpleAutoCompleteList = new Array();
        if (vendorCodeData.length > 0 && vendorCodeData != null) {
          vendorCodeData.map((vendorCode) => {
            let simpleItemBean = {
              code: vendorCode.code,
              description: vendorCode.description,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          vendorPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    };
    vendorCodeEnterKeyEventHandler = (e) => {
      let vendorCode = e.target.value;
      this.readandsetVendorDetail(vendorCode);
      this.setState({
        vendorPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteVendorList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
    };

    errorCallBack = (error) => {
      ShowError(error);
    };

    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>VendorInvoice</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="vendorInvoiceCode"
                  name="vendorInvoiceCode"
                  onChange={this.onChange}
                  value={searchCriteria.vendorInvoiceCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Vendor Ref Invoice Number</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="vendorInvoiceReferenceNumber"
                  name="vendorInvoiceReferenceNumber"
                  onChange={this.onChange}
                  value={searchCriteria.vendorInvoiceReferenceNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>VendorType</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="vendorType"
                  name="vendorType"
                  onChange={this.onChange}
                  value={searchCriteria.vendorType}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Vendor</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="vendorCode"
                  name="vendorCode"
                  onChange={this.vendorCodeOnChange}
                  value={searchCriteria.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteVendorList}
                  showAutoCompleteList={this.state.showAutoCompleteVendorList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="status"
                  value={searchCriteria.status}
                >
                  <option value={""}></option>
                  <option value={"A"}>Approved</option>
                  <option value={"U"}>UnApproved</option>
                  <option value={"F"}>Paid</option>
                  <option value={"P"}>Partially Paid</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel>Invoice Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="invoiceDate"
                  name="invoiceDate"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceDate}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>Due Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="invoiceDueDate"
                  name="invoiceDueDate"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceDueDate}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <FormLabel>Invoice From Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="invoiceFromDate"
                  name="invoiceFromDate"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceFromDate}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="invoiceToDate"
                  name="invoiceToDate"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceToDate}
                />
              </Col>
            </Row>

            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
